export const IMG_PLACEHOLDER = "/placeholder-image.svg";
export const AVATAR_PLACEHOLDER = "/placeholder-avatar.svg";

// Swap a failed <img> to a placeholder once (guarded so a missing placeholder can't loop).
export const imgFallback = (fallback = IMG_PLACEHOLDER) => (e) => {
  const img = e.currentTarget;
  if (img.dataset.fallback) return;
  img.dataset.fallback = "1";
  img.removeAttribute("srcset");
  img.src = fallback;
};

export const onImgError = imgFallback(IMG_PLACEHOLDER);
export const onAvatarError = imgFallback(AVATAR_PLACEHOLDER);
